import React, { Component } from 'react';
import { Link } from 'react-router';

import { BrowserRouter as Router, Routes, Route } from 'react-router';
import './App.css';
import './ColorPalette.css';
import './Helper.css';


import { Imprint } from './components/Imprint';
import Login from './components/Login';
import Register from './components/Register';
import ReleaseNotes from './components/ReleaseNotes';
import Wiki from './components/Wiki';
import { GameHome } from './components/Game/Game_Home';
import PublicShell from './components/PublicShell';

import { apiGet } from './Api';
import HOME from './components/Home';
import ADMIN_HOME from './components/Admin/Admin_Home';

function GameAccessScreen({ status, onRetry, onLogout }) {
  const checking = status === 'checking';
  const failed = status === 'error';

  return (
    <PublicShell compact authenticated>
      <section
        className="auth-card"
        aria-labelledby="game-access-title"
        aria-busy={checking}
      >
        <p className="auth-card__eyebrow">
          {checking ? 'Checking access' : failed ? 'Access check unavailable' : 'Pre-registration received'}
        </p>
        <h1 id="game-access-title">
          {checking ? 'Checking alpha access' : failed ? 'Please try again' : "You're pre-registered"}
        </h1>
        <p className="auth-card__intro">
          {checking
            ? 'Confirming whether your account can enter the closed alpha.'
            : failed
              ? 'We could not confirm your access right now. Retry before entering the game.'
              : "Thanks for signing up. We'll email you as soon as your closed-alpha access is ready."}
        </p>

        <div className="auth-form">
          {failed && (
            <button className="auth-button" type="button" onClick={onRetry}>
              Retry access check
            </button>
          )}
          <button
            className="auth-button auth-button--secondary"
            type="button"
            onClick={onLogout}
          >
            Log out
          </button>
        </div>
      </section>
    </PublicShell>
  );
}

export default class App extends Component {
  static displayName = App.name;

  constructor(props) {
    super(props);
    const token = localStorage.getItem('token');
    this.state = {
      token,
      accessStatus: token ? 'checking' : 'signed-out',
      version: "0.0.0"
    }
  }

  componentDidMount() {
    window.addEventListener('storage', this.handleStorageChange);
    this.getVersion();
    if (this.state.token) {
      this.checkGameAccess();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.handleStorageChange);
  }

  getVersion = async () => {
    try {
      const response = await apiGet("/version/");
      if (response.ok) {
        const v = await response.text();
        const local_v = localStorage.getItem('version');
        if (local_v === null || v !== local_v) {
          console.log('Clearing cache and hard reloading...')
          if ('caches' in window) {
            caches.keys().then(function (names) {
              for (let name of names) {
                caches.delete(name);
              }
            }).then(function () {
              console.log('All caches cleared.');
            }).catch(function (error) {
              console.error('Error clearing caches:', error);
            });
          }
          window.location.reload(true);
          localStorage.setItem('version', v);
        }
        this.setState({ version: v });
      }
    } catch {
      // Public and authentication pages remain usable during a temporary API outage.
    }
  }

  loadTokenFromLocalStorage = () => {
    const token = localStorage.getItem('token');
    this.setState({
      token,
      accessStatus: token ? 'checking' : 'signed-out',
    }, () => {
      if (token) this.checkGameAccess();
    });
  };

  handleStorageChange = () => {
    this.loadTokenFromLocalStorage();
  };

  handleLogin = (token) => {
    this.setState({
      token,
      accessStatus: 'checking',
    }, this.checkGameAccess);
  };

  checkGameAccess = async () => {
    const checkedToken = this.state.token;
    if (!checkedToken) return;

    try {
      const response = await apiGet('/user/access');
      const result = await response.json();
      if (this.state.token !== checkedToken) return;

      this.setState({
        accessStatus: (result.gameAccess ?? result.GameAccess)
          ? 'allowed'
          : 'waiting',
      });
    } catch {
      if (this.state.token === checkedToken) {
        this.setState({ accessStatus: 'error' });
      }
    }
  };

  retryGameAccess = () => {
    this.setState({ accessStatus: 'checking' }, this.checkGameAccess);
  };

  handleLogout = () => {
    localStorage.removeItem('token');
    this.setState({
      token: null,
      accessStatus: 'signed-out',
    });
  };

  render() {
    const { token, accessStatus } = this.state;
    const gameAccessScreen = (
      <GameAccessScreen
        status={accessStatus}
        onRetry={this.retryGameAccess}
        onLogout={this.handleLogout}
      />
    );

    return (
      <div className="apppage">

        <Router>
          <Routes>
            <Route path='/imprint' element={<Imprint />} />
            <Route path='/changelog' element={<ReleaseNotes />} />
            <Route path='/wiki' element={<Wiki />} />
            <Route path='/wiki/:slug' element={<Wiki />} />
            {token ? (
              <>
                <Route
                  path="/admin/*"
                  element={accessStatus === 'allowed' ? <ADMIN_HOME /> : gameAccessScreen}
                />
                <Route
                  path='/login'
                  element={accessStatus === 'allowed' ? <GameHome /> : gameAccessScreen}
                />
                <Route
                  path='/'
                  element={accessStatus === 'allowed' ? <GameHome /> : gameAccessScreen}
                />
              </>
            ) : (
              <>
                <Route path='/login' element={<Login handleLogin={this.handleLogin} />} />
                <Route path='/register' element={<Register />} />
                <Route path='/' element={<HOME></HOME>} />
              </>
            )}
            {/* <Route path='*' element={<Navigate to='/' />} /> */}
          </Routes>

          <footer className='footer' aria-label="Site information">
            <Link to='/imprint'>Imprint</Link>
            <Link to='/wiki'>Wiki</Link>
            <Link to='/changelog'>Release notes</Link>
            <span className='versionumber'>Version {this.state.version}</span>
          </footer>
        </Router>

      </div>
    );
  }
}
